import { getLandingRoute } from "@/components/layout/navigation";
import type { PermissionRole } from "@/components/layout/navigation";
import {
  getCurrentUserRole,
  getPermissionsFromToken,
  isInternal,
  isMigratedToProfiles,
} from "@/utils/keycloakRoles";

/**
 * Primeira rota que o usuário consegue abrir, lida SÓ do token — GR-637.
 *
 * Os cinco pontos que decidem o pouso pós-login rodam antes de a query de
 * perfil existir (`LoginRedirect` é o callback do OAuth: o token acabou de
 * chegar e mais nada carregou). Tudo de que a decisão precisa já está no JWT,
 * de forma síncrona: papel, client roles, membership em grupo e realm.
 *
 * Mandar todo mundo para `/dashboard`, como era antes, faz quem não tem
 * `view-dashboard` cair em acesso negado como PRIMEIRA tela depois de logar —
 * o que lê como login quebrado, não como falta de permissão.
 */
export function getLandingRouteFromToken(): string {
  return getLandingRoute(getCurrentUserRole() as PermissionRole | null, {
    permissions: getPermissionsFromToken(),
    isMigrated: isMigratedToProfiles(),
    isInternal: isInternal(),
  });
}
